"use client";
import "@/components/help/help-sidebar.css";
import "@/components/ui/atoms/categories/layout.css";
import "@/components/ui/molecules/categories/page-chrome.css";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { memo } from "react";

const NAV_SECTIONS: {
    title: string;
    items: {
        title: string;
        href: string;
    }[];
}[] = [{ title: "Get Started", items: [{ title: "Introduction", href: "/help" }, { title: "Quickstart", href: "/help/quickstart" }, { title: "Key Concepts", href: "/help/concepts" }] }, { title: "Credit Basics", items: [{ title: "Understanding Credit Reports", href: "/help/credit-reports" }, { title: "Metro 2® Compliance", href: "/help/metro2" }, { title: "Credit Scores Explained", href: "/help/credit-scores" }, { title: "The Three Bureaus", href: "/help/bureaus" }, { title: "Glossary", href: "/help/glossary" }] }, { title: "Disputes", items: [{ title: "How Disputes Work", href: "/help/disputes" }, { title: "Writing Effective Letters", href: "/help/letters" }, { title: "Common Dispute Reasons", href: "/help/dispute-reasons" }] }, { title: "Using DisputeWell", items: [{ title: "Why Choose DisputeWell?", href: "/help/features" }, { title: "Importing Reports", href: "/help/importing" }, { title: "AI Letter Assistant", href: "/help/ai-assistant" }, { title: "Tracking Progress", href: "/help/tracking" }] }, { title: "Legal & Compliance", items: [{ title: "Your Rights (FCRA)", href: "/help/fcra" }, { title: "FDCPA Protections", href: "/help/fdcpa" }, { title: "FAQ", href: "/help/faq" }] }];

export const HelpSidebar = memo(function HelpSidebar() {
    const pathname = usePathname();

    return (
        <aside className="dw-help-sidebar dw-bar" data-edge="inline-end" data-component="HelpSidebar" data-location="src/components/help/HelpSidebar.tsx">
            <div className="dw-help-sidebar__scroll">
                <nav aria-label="Help article navigation" className="dw-help-sidebar__nav">
                    {NAV_SECTIONS.map((section) => (
                        <div key={section.title}>
                            <h3 className="dw-help-sidebar__section-heading dw-eyebrow">{section.title}</h3>
                            <ul className="dw-help-sidebar__items dw-list">
                                {section.items.map((item) => {
                                    const isActive = pathname === item.href;
                                    return (
                                        <li key={item.href}>
                                            <Link href={item.href} className="dw-help-sidebar__link dw-quiet-link dw-text-body" data-tone={isActive ? "primary" : "muted"} aria-current={isActive ? "page" : undefined}>{item.title}</Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ))}
                </nav>
            </div>
        </aside>
    );
});
